var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('app-creation-modal',{attrs:{"data-activator-text":_vm.$t('message.generics.message.register'),"data-entity":"tag"}}),_c('div',{staticClass:"search-wrapper"},[_c('app-search',{on:{"submit":_vm.search}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }